import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-notice',
  template: `
    <div class="notice" [ngClass]="[type, hug ? 'hug' : '']">
      <div class="notice-header" *ngIf="title">
        <span class="notice-icon material-icons">{{ iconToDisplay }}</span>
        <h3 class="notice-title">{{ title }}</h3>
      </div>
      <p class="notice-body" *ngIf="body">{{ body }}</p>
    </div>
  `,
  styles: [
    `
      .notice {
        border: 2px solid;
        border-radius: 8px;
        margin: 16px 0;
        padding: 16px;
        transition: all 0.3s ease;
        display: block;
      }
      /* Hug style: shrink to fit content */
      .notice.hug {
        padding: 8px;
        display: inline-block;
        width: fit-content;
      }
      .notice-header {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }
      .notice-icon {
        margin-right: 8px;
        font-size: 24px;
        line-height: 1;
      }
      /* Warning style */
      .notice.warning {
        background-color: #fff3cd;
        border-color: #ffeeba;
        color: #856404;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
      /* Error style */
      .notice.error {
        background-color: #f8d7da;
        border-color: #f5c6cb;
        color: #721c24;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
      /* Success style */
      .notice.success {
        background-color: #d4edda;
        border-color: #c3e6cb;
        color: #155724;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
      /* Info style */
      .notice.info {
        background-color: #d1ecf1;
        border-color: #bee5eb;
        color: #0c5460;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
      .notice-title {
        margin: 0;
      }
      .notice-body {
        margin: 0;
        font-size: 1rem;
      }
    `,
  ],
})
export class CsNoticeComponent {
  @Input() title: string = '';
  @Input() body: string = '';
  @Input() type: 'warning' | 'error' | 'success' | 'info' = 'info';
  @Input() hug: boolean = false;
  // Optional override icon; if not provided, icon is set based on type.
  @Input() icon?: string;

  get iconToDisplay(): string {
    if (this.icon) {
      return this.icon;
    }
    const icons: { [key: string]: string } = {
      warning: 'warning',
      error: 'error',
      success: 'check_circle',
      info: 'info',
    };
    return icons[this.type] || 'info';
  }
}
